const defaultState = {
  list: [],
  item: null,
  loaded: false,
}


const label = (state = defaultState, action) => {
  switch (action.type) {
    case 'GET_LABELS':
      return {...state, list: action.data, loaded: true,}
    case 'ADD_LABEL':
        return {
          ...state, 
          list: [...state.list, action.data],
          loaded: true,
        }  
    case 'UPDATE_LABEL':
        return {
          ...state, 
          list: state.list.map(_i => _i.id == action.data.id ? action.data : _i),
          loaded: true,
        }  
    case 'DELETE_LABEL':
      return {...state, list: state.list.filter(item => item.id != action.data), loaded: true,}  
    case 'SET_KEY_LABEL':
      return {...state, [action.key]: action.data}  
    default:
      return state;
  }
}

export default label;


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/redux/reducers/label.js